export default __webpack_public_path__ + "static/media/name.d4bfc739.svg";